/**
 * Kopiert Text in die Zwischenablage.
 * Nutzt Clipboard API, sonst execCommand — fängt Permissions-Policy-Fehler ab
 * (z. B. in iframes ohne clipboard-write).
 * @param {string} text
 * @returns {Promise<boolean>} true bei Erfolg
 */
export async function copyTextToClipboard(text) {
  const value = String(text ?? '');
  if (!value) return false;

  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(value);
      return true;
    }
  } catch {
    /* Permissions-Policy / unsicherer Kontext → Fallback */
  }

  try {
    const ta = document.createElement('textarea');
    ta.value = value;
    ta.setAttribute('readonly', '');
    ta.style.cssText =
      'position:fixed;left:-9999px;top:0;opacity:0;pointer-events:none;';
    document.body.appendChild(ta);
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, value.length);
    const ok = document.execCommand('copy');
    document.body.removeChild(ta);
    if (ok) return true;
  } catch {
    /* ignore */
  }

  return false;
}
